import React from 'react';
import { HashRouter as Router, Route, Switch, Redirect,BrowserRouter} from 'react-router-dom';
import NotFound from './components/pages/NotFound';
import Login from './components/pages/Login';
import App from './App';
import SignUp from './components/pages/SignUp';
import SsoCallback from './components/pages/SsoCallback';

export default () => (

    <BrowserRouter>
        <Switch>
            <Route path="/load" render={() =><App />} />
            <Route path="/404" render={() =><NotFound />} />
            <Route exact path="/" render={() =><Login/>} />
            <Route path="/sign-up" render={() =><SignUp/>} />
            <Route path="/sso-callback" render={() =><SsoCallback />} />
            <Route path="/signin" render={() =><Login/>} />
            <Route render={() =><App/>} />
        </Switch>
    </BrowserRouter>

)
